/*
  No Size Selected state (snippets/sm-no-size-selected.liquid). The configurator in
  sm-reusable-product_product / assets/sm-main-product-navigation.js clears `sm-nv-pending`
  when a size is chosen and calls smNoSize.sync after every option update; this file keeps
  the Size label on the chosen card, scrolls back to the sizes, and stops a pending form
  from adding the default variant.
*/
(() => {
  if (window.smNoSize) return;

  const sizeWrapper = (root) => root && root.querySelector('.smoker_size-wrapper[data-sm-smoker-size]');

  const scrollToSizes = (root) => {
    const wrapper = sizeWrapper(root);
    if (!wrapper) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('.section-header .header-wrapper, sticky-header');
    const offset = header ? header.getBoundingClientRect().height + 16 : 16;
    const top = wrapper.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    const first = wrapper.querySelector('.smoker_size:not([hidden])');
    if (first) first.setAttribute('tabindex', '-1');
    if (first) first.focus({ preventScroll: true });
  };

  window.smNoSize = {
    /* Size label beside the heading: the active card's title. */
    sync(root) {
      const wrapper = sizeWrapper(root);
      const valueNode = wrapper && wrapper.querySelector('[data-sm-size-value]');
      if (!valueNode) return;
      const active = wrapper.querySelector('[data-sm-option-value].active');
      const title = active && active.closest('.smoker_size')?.querySelector('.smoker_size-text h6');
      const text = (title ? title.textContent : active ? active.dataset.smOptionValue : '').trim();
      if (text && valueNode.textContent !== text) valueNode.textContent = text;
    },
    scrollToSizes,
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sm-nv-scroll], a[href="#select-size"]');
    if (!trigger) return;
    const root = trigger.closest('product-info') || document.querySelector('product-info.sm-nv-pending') || document.querySelector('product-info');
    if (!sizeWrapper(root)) return;
    event.preventDefault();
    scrollToSizes(root);
  });

  /* Enter in the quantity field, or another script, could still submit the form. */
  document.addEventListener('submit', (event) => {
    const root = event.target.closest('.sm-nv-pending');
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToSizes(root);
  }, true);

  document.querySelectorAll('product-info').forEach((root) => window.smNoSize.sync(root));
})();
